export default __webpack_public_path__ + "static/media/nave-reuveni-11.01dbc064.png";